import React from 'react';
import NavbarDefault from "../components/navbarDefault";
import FooterDefault from "../components/footerDefault";
import { Grid, Typography } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { createTheme, responsiveFontSizes } from '@mui/material';
import { ThemeProvider } from '@emotion/react';

let theme = createTheme({
  typography: {
    fontFamily: [
      'Segoe UI', 
      'sans-serif',
    ].join(','),
  }
});

theme = responsiveFontSizes(theme);

function createData(S1, U1, S2, U2){
    return {S1, U1, S2, U2};
}

const first =[
    createData('GE (Kas 1)', 3, 'GE (SocSci 1 / SocSci 2)', 3),
    createData('GE (Philo 1)', 3, 'CS 12 (Computer Programming II)', 3),
    createData('CS 10 (Introduction to Computing)',	3, 'CS 31 (Discrete Mathematics for CS II)', 3),
    createData('CS 11 (Computer Programming I)', 3, 'Math 22 (Elementary Analysis II)', 4),
    createData('CS 30 (Discrete Mathematics for CS I)', 3, 'Physics 71 (Elementary Physics I)', 4),
    createData('Math 21 (Elementary Analysis I)', 4, 'PE', '(2)'),
    createData('PE', '(2)', '', ''),
];

const second = [
    createData('GE (Eng 13)', 3,'GE (Speech 30)', 3),
    createData('CS 20 (Digital Electronics and Circuits)', 3, 'CS 21 (Computer Organization and Architecture)', 4),
    createData('CS 32 (Data Structures and Algorithms I)', 4, 'CS 33 (Data Structures and Algorithms II)', 4),
    createData('Math 23 (Elementary Analysis III)', 4, 'CS 136 (Elementary Numerical Computing I)', 3),
    createData('Physics 72 (Elementary Physics II)', 4, 'Math 40 (Linear Algebra)', 3),
    createData('PE', '(2)', 'PE', '(2)'),
    createData('NSTP', '(3)', 'NSTP', '(3)'),
];

const third = [
    createData('GE (Fil 40)', 3, 'GE (Eng 30)', 3),
    createData('CS 138 (Elementary Numerical Computing II)', 3,	'CS 145 (Computer Networks)', 4),
    createData('CS 140 (Operating Systems)', 4, 'CS 153 (Introduction to Computer Security)', 3),
    createData('CS 150 (Programming Languages)', 3, 'CS 180 (Artificial Intelligence)', 3),
    createData('CS 165 (Database Systems)', 4, 'CS 192 (Software Engineering II)', 3),
    createData('CS 191 (Software Engineering I)', 3, 'CS 194 (Undergraduate Research Seminar)', 1),
];

const fourth = [
    createData('GE (STS 1/DRMAPS)', 3, 'GE (Arts 1)', 3),
    createData('GE (Free Choice)', 3, 'CS 132 (Introduction to Data Science)', 3),
    createData('CS 133 (Automata Theory and Complexity)', 3, 'CS 155 (Compiler Construction)', 3),
    createData('CS 198 (Special Project I)', 3,	'CS 196 (Seminar on EPIC)', 1),
    createData('Elective (Free Choice)', 3, 'CS 199/200 (Special Project II)', 3),
    createData('Elective (Engg 150)', 3, 'Elective (CS)', 3),
    createData('', '', 'PI 100', 3),
];

function Curriculum() {
    return(
        <ThemeProvider theme={theme}>
            <NavbarDefault />
                <Grid         
                    container
                    direction="row"
                    justifyContent="center"
                    height="50%"
                    sx={{ flexGrow: 1, 
                    paddingBottom: 2,
                    paddingRight: 2,
                    marginTop: 2,
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginBottom: 5,
                    maxWidth: 1,
                    alignItems: "center"
                    }}
                    spacing={2}
                >
                    <Grid item xs={8} sx={{textAlign: 'justify'}}>
                        <Typography variant='h4' fontFamily="Segoe UI" fontWeight={700} marginBottom={4}>
                            BACHELOR OF SCIENCE IN COMPUTER SCIENCE CURRICULUM
                        </Typography>
                        <Typography variant='b1' fontFamily="Segoe UI">
                            The Department of Computer Science offers one program for undergraduates: the Bachelor of Science in Computer Science (B.Sc. C.S.) program.
                        </Typography>
                        <Typography variant='h5' fontFamily="Segoe UI" fontWeight={700} gutterBottom marginTop={2}>
                            Latest Revision - 2018
                        </Typography>
                        <Typography variant='b1' fontFamily="Segoe UI">
                            The Department of Computer Science offers one program for undergraduates: the Bachelor of Science in Computer Science (B.Sc. C.S.) program.
                            The B.Sc. C.S. curriculum was last revised in 2018 in response to the nation-wide shift to a K-12 education system. With 148 units taken over four years 
                            (including one required mid-year term - for internship), the 2018 curriculum takes into account the latest developments and trends in the field of Computer Science, 
                            feedback from the industry, new competencies from students produced by the K-12 primary/secondary school system (with particular focus on graduates of the Science, 
                            Technology, Engineering and Mathematics (STEM) strand), and recommendations from professional bodies such as the Association of Computing Machinery (through its 
                            Curriculum Guidelines for Undergraduate Degree Programs in Computer Science, 2013).
                        </Typography>
                        <Typography variant='h5' fontFamily="Segoe UI" fontWeight={700} gutterBottom marginTop={2}>
                            Curriculum Design Principle
                        </Typography>
                        <Typography variant='b1' fontFamily="Segoe UI">
                            2018 curriculum is designed to be fundamentals-driven, emphasizing core principles and competencies that would enable the students (and eventual graduates) to adapt
                             and learn new skills in an ever-changing technological and professional landscape. As such, very few, if any, of the courses in the curriculum cater to a specific technology 
                             (Java, Cisco, etc.) or skill (object-oriented programming, web programming, drone programming, etc.). The students would learn these technologies/skills, but they would do 
                             so in the context of these technologies/skills being used in learning more fundamental courses (e.g., object oriented programming through the programming language course, 
                             mobile/web programming through the software engineering course), most of which are reinforced with laboratory units to foster learning and experimentation ("learning by doing").
                        </Typography>
                        <Typography variant='h5' fontFamily="Segoe UI" fontWeight={700} gutterBottom marginTop={2}>
                            Specialization
                        </Typography>
                        <Typography variant='b1' fontFamily="Segoe UI">
                            The B.Sc. C.S. degree has no explicit specialization which appears in the diploma or transcript (e.g. Bachelor of Science in Computer Science, Major in Network Technologies). 
                            This is partly in observance of the general principle of making the program fundamentals-driven, and partly to encourage the students to take charge of their own learning through 
                            electives and additional courses they may take in the University. Nevertheless, the students do end up having a de-facto specialization of sorts, since membership in one of the Department's 
                            eight research laboratories/groups is required for taking up CS 198/199/200 (Special Project I/Special Project II/Undergraduate Thesis). The year-long project undertaken by the student under 
                            one of the research laboratories, combined with electives and additional courses, serve as the specialization mechanisms of the curriculum.
                        </Typography>
                        <Typography variant='h5' fontFamily="Segoe UI" fontWeight={700} gutterBottom marginTop={2}>
                            B.Sc. C.S. Curriculum Checklist
                        </Typography>
                        <Typography variant='h6' fontFamily="Segoe UI" fontWeight={700} gutterBottom marginTop={2}>
                            <i>First Year</i>
                        </Typography>
                        <TableContainer component={Paper} sx={{flexGrow:1}}>
                            <Table sx={{width:1}} aria-label='simple table'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align='left'>First Semester</TableCell>
                                        <TableCell align='left'>19 Units</TableCell>
                                        <TableCell align='left'>Second Semester</TableCell>
                                        <TableCell align='left'>17 Units</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {first.map((first) => (
                                        <TableRow
                                        key={first.name}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">{first.S1}</TableCell>
                                            <TableCell align='left'>{first.U1}</TableCell>
                                            <TableCell align="left">{first.S2}</TableCell>
                                            <TableCell align="left">{first.U2}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Typography variant='h6' fontFamily="Segoe UI" fontWeight={700} gutterBottom marginTop={4}>
                            <i>Second Year</i>
                        </Typography>
                        <TableContainer component={Paper} sx={{flexGrow:1}}>
                            <Table sx={{width:1}} aria-label='simple table'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align='left'>First Semester</TableCell>
                                        <TableCell align='left'>18 Units</TableCell>
                                        <TableCell align='left'>Second Semester</TableCell>
                                        <TableCell align='left'>17 Units</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {second.map((second) => (
                                        <TableRow
                                        key={second.name}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">{second.S1}</TableCell>
                                            <TableCell align='left'>{second.U1}</TableCell>
                                            <TableCell align="left">{second.S2}</TableCell>
                                            <TableCell align="left">{second.U2}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Typography variant='h6' fontFamily="Segoe UI" fontWeight={700} gutterBottom marginTop={4}>
                            <i>Third Year</i>
                        </Typography>
                        <TableContainer component={Paper} sx={{flexGrow:1}}>
                            <Table sx={{width:1}} aria-label='simple table'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align='left'>First Semester</TableCell>
                                        <TableCell align='left'>20 Units</TableCell>
                                        <TableCell align='left'>Second Semester</TableCell>
                                        <TableCell align='left'>17 Units</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {third.map((third) => (
                                        <TableRow
                                        key={third.name}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">{third.S1}</TableCell>
                                            <TableCell align='left'>{third.U1}</TableCell>
                                            <TableCell align="left">{third.S2}</TableCell>
                                            <TableCell align="left">{third.U2}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Typography variant='h6' fontFamily="Segoe UI" fontWeight={700} gutterBottom marginTop={4}>
                            <i>Fourth Year</i>
                        </Typography>
                        <TableContainer component={Paper} sx={{flexGrow:1}}>
                            <Table sx={{width:1}} aria-label='simple table'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align='left'>First Semester</TableCell>
                                        <TableCell align='left'>18 Units</TableCell>
                                        <TableCell align='left'>Second Semester</TableCell>
                                        <TableCell align='left'>19 Units</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {fourth.map((fourth) => (
                                        <TableRow
                                        key={fourth.name}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">{fourth.S1}</TableCell>
                                            <TableCell align='left'>{fourth.U1}</TableCell>
                                            <TableCell align="left">{fourth.S2}</TableCell>
                                            <TableCell align="left">{fourth.U2}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            <FooterDefault />
        </ThemeProvider>
    )
}

export default Curriculum